module.exports = __webpack_public_path__ + "static/media/ms-box.30204ed9.png";